import { useState } from "react";
import Frame from "../Frame";
import styles from "./SalesRepresentativeBanner.module.scss";
import Icon from "../Icon";
import FrameHeader from "../FrameHeader";
import Space from "../Space";
export default function SalesRepresentativeBanner() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <>
      <FrameHeader title="Attention Needed" />
      <Frame>
        <div className={styles.headerRow}>
          <button
            className={styles.hideButton}
            onClick={() => setVisible(false)}
            aria-label="Hide banner"
          >
            <Icon name="close" size={22} />
          </button>
        </div>
        <div className={styles.infoText}>
          If you have an account with Traffix Devices and would like to use your
          resale certificate, please place your subscription order directly with
          your customer service representative at{" "}
          <b>
            <a href="mailto:orders@traffixdevices.com">
              orders@traffixdevices.com
            </a>
          </b>
        </div>
      </Frame>
      <Space size="s" />
    </>
  );
}
